import { useState } from "react";
import { Sparkles, Plus } from "lucide-react";
import { toast } from "sonner";
import { adoptMasterWithPrices } from "@/lib/api";

const SuggestionRow = ({ cand, onAdded }) => {
  const [price, setPrice] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async () => {
    const p = parseFloat(price);
    if (!p || p <= 0) return toast.error("Escribe el precio de venta");
    setBusy(true);
    try {
      const r = await adoptMasterWithPrices([{ master_product_id: cand.id, sale_price: p }]);
      const prod = (r.products || []).find((x) => x.master_product_id === cand.id);
      if (!prod) throw new Error("no product");
      onAdded({ product_id: prod.id, name: prod.name, quantity: 1, unit_price: prod.sale_price, unit: prod.unit, subtotal: prod.sale_price, category: prod.category, resolved_by: "catalog_suggestion" });
      toast.success(`${prod.name} ya está en tu inventario y en el ticket`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo agregar");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2 bg-black/40 border border-white/10 rounded-xl px-3 py-2" data-testid={`suggestion-${cand.id}`}>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] text-white/90 truncate" data-testid={`suggestion-name-${cand.id}`}>{cand.pretty}</p>
        <p className="font-mono text-[10px] text-white/40 truncate">{cand.category}{cand.barcode ? ` · ${cand.barcode}` : ""}</p>
      </div>
      <div className="flex items-center gap-1 bg-black/60 border border-white/10 rounded-lg px-2">
        <span className="text-white/40 text-xs">$</span>
        <input
          type="number" inputMode="decimal" min="0" step="0.5" value={price}
          onChange={(e) => setPrice(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && add()}
          placeholder="precio" className="w-20 bg-transparent py-1.5 text-sm outline-none"
          data-testid={`suggestion-price-${cand.id}`}
        />
      </div>
      <button onClick={add} disabled={busy} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-[#ccff00] text-black text-[10px] font-mono uppercase tracking-widest hover:bg-[#d9ff33] disabled:opacity-50" data-testid={`suggestion-add-${cand.id}`}>
        <Plus size={12} /> Sumar
      </button>
    </div>
  );
};

export const CatalogSuggestions = ({ suggestions, onAdded }) => {
  const [done, setDone] = useState(new Set());
  if (!suggestions?.length) return null;
  const visible = suggestions.filter((s) => !done.has(s.query));
  if (!visible.length) return null;
  return (
    <div className="mt-3 pt-3 border-t border-white/10 space-y-3" data-testid="catalog-suggestions">
      {visible.map((s) => (
        <div key={s.query}>
          <div className="flex items-center gap-2 mb-2 text-[11px] text-[#ccff00]">
            <Sparkles size={13} />
            <span>¿Te refieres a alguno de estos del catálogo global para <strong>“{s.query}”</strong>? Ponle precio y lo sumo al ticket.</span>
          </div>
          <div className="space-y-1.5">
            {s.candidates.map((c) => (
              <SuggestionRow key={c.id} cand={c} onAdded={(item) => { setDone((d) => new Set(d).add(s.query)); onAdded(item); }} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
